var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpPointArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50488 0.495121C6.22604 0.216286 5.77396 0.216286 5.49512 0.495121L0.951219 5.03902C0.672382 5.31786 0.672382 5.76994 0.951219 6.04878C1.23006 6.32762 1.68214 6.32762 1.96098 6.04878L6 2.00976L10.039 6.04878C10.3179 6.32762 10.7699 6.32762 11.0488 6.04878C11.3276 5.76995 11.3276 5.31786 11.0488 5.03902L6.50488 0.495121ZM6.71401 27L6.71401 25.7L5.28599 25.7L5.28599 27L6.71401 27ZM6.71401 23.1L6.71401 20.5L5.28599 20.5L5.28599 23.1L6.71401 23.1ZM6.71401 17.9L6.71401 15.3L5.28599 15.3L5.28599 17.9L6.71401 17.9ZM6.71401 12.7L6.71401 10.1L5.286 10.1L5.286 12.7L6.71401 12.7ZM6.71401 7.5L6.71401 4.9L5.286 4.9L5.286 7.5L6.71401 7.5ZM6.71401 2.3L6.71401 1L5.286 1L5.286 2.3L6.71401 2.3Z",
    fill: "#239F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpPointArrow);
export default __webpack_public_path__ + "static/media/up-point-arrow.1b6136753fdc59503ff8615d9ef10130.svg";
export { ForwardRef as ReactComponent };